import * as React from 'react';

import classNames from 'classnames';
import { throttle } from 'throttle-debounce';

import { getLineHeight } from '@utils';

import { ITranslatable, Translate, TranslateFn } from '@decorators';

import { ICollapsibleTextBlockProps, ICollapsibleTextBlockState } from './types';

import * as s from './CollapsibleTextBlock.scss';

const HEIGHT_INITIAL = 'none';

@Translate('base.components.ui.CollapsibleTextBlock')
export class CollapsibleTextBlock extends React.Component <ICollapsibleTextBlockProps, ICollapsibleTextBlockState> implements ITranslatable {

	declare t: TranslateFn;

	state: ICollapsibleTextBlockState = {
		isNeedCollapse: false,
		isExpand: this.props.isExpand || false,
		blockHeight: HEIGHT_INITIAL,
	};

	outerBlock: React.RefObject<HTMLDivElement> = React.createRef();
	innerBlock: React.RefObject<HTMLDivElement> = React.createRef();
	showMoreBtn: React.RefObject<HTMLDivElement> = React.createRef();
	trimmedHeight: number;

	componentDidMount(): void {
		this.setTrimmedHeight(this.props.lineToShow * getLineHeight(this.outerBlock.current));
		this.configureBlock();

		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	setTrimmedHeight = (value: number) => {
		this.trimmedHeight = value;
	};

	toggleExpanding = (isExpand: boolean) => {
		const contentHeight = this.innerBlock.current.clientHeight + this.showMoreBtn.current.clientHeight;
		const containerHeight = isExpand ? contentHeight : this.trimmedHeight;

		this.setState({
			isExpand,
			blockHeight: containerHeight + 'px',
		});
	};

	configureBlock = () => {
		const contentHeight = this.innerBlock.current.clientHeight;
		const isNeedCollapse = contentHeight > this.trimmedHeight;
		let containerHeight;

		if (this.state.isExpand) {
			containerHeight = contentHeight + this.showMoreBtn.current?.clientHeight + 'px';
		} else {
			containerHeight = isNeedCollapse ? this.trimmedHeight + 'px' : 'auto';
		}

		this.setState({
			isNeedCollapse,
			blockHeight: containerHeight,
		});
	};

	onResize = throttle(300, this.configureBlock);

	onShowMoreCLick = () => {
		this.toggleExpanding(!this.state.isExpand);
	};

	renderShowMoreBtn = () => {
		const className = classNames(s.showMoreBtn, { [s.isExpand]: this.state.isExpand });

		return (
			<div onClick={this.onShowMoreCLick} className={className} ref={this.showMoreBtn}>
				{this.state.isExpand
					? this.props.collapseBtn || <div>{this.t('collapse')}</div>
					: this.props.expandBtn || <div>{this.t('expand')}</div>
				}
			</div>
		);
	};

	render() {
		const {
			className,
			text,
		} = this.props;
		const {
			isNeedCollapse,
			blockHeight,
		} = this.state;
		const blockClassName = classNames(
			className,
			s.block,
		);
		const button = this.renderShowMoreBtn();

		return (
			<div
				ref={this.outerBlock}
				style={{ height: blockHeight }}
				className={blockClassName}
			>
				<div ref={this.innerBlock}>
					<span className={this.props.textClass}>{text}</span>
				</div>
				{isNeedCollapse && button}
			</div>
		);
	}

}

